import api from "./axios";

const BASE = "/dashboard";

/**
 * Overall tab — KPI tiles, both trend graphs and Top Performers.
 * Requires `year`; `month` is optional (year alone = whole year).
 * Zones are sent comma-joined (`zones=id1,id2`).
 */
export const getDashboardOverall = async (params = {}) => {
  const response = await api.get(`${BASE}/overall`, { params });
  return response.data;
};

/**
 * Summary tab — the 12 KPI tiles.
 * Year/Month are optional here ("All" is valid); a month still needs a year.
 */
export const getDashboardSummary = async (params = {}) => {
  const response = await api.get(`${BASE}/summary`, { params });
  return response.data;
};

/**
 * Performance tab — 4 KPI tiles plus the paginated partner roster.
 * Year/Month and fromDate/toDate are mutually exclusive; send only one.
 */
export const getDashboardPerformance = async (params = {}) => {
  const response = await api.get(`${BASE}/performance`, { params });
  return response.data;
};

/**
 * Onboarding sub-tab — document completion across active partners.
 * Takes no filters by design: always a company-wide, all-time snapshot.
 */
export const getDashboardOnboarding = async () => {
  const response = await api.get(`${BASE}/onboarding`);
  return response.data;
};
